import React from 'react';
import { FormattedMessage, FormattedDate, FormattedTime } from 'react-intl';
import Svg from '@jg/svg';
import clock from '@jg/icons/lib/clock.svg';
import { getLastUpdated } from 'src/helpers/date';
import { SupporterResource } from 'src/helpers/api/activities';
import { UpdateResource } from 'src/helpers/api/updates';

export interface Props {
  createdAt: string;
  activatedAt: string;
  supporters: SupporterResource[];
  updates: UpdateResource[];
}

const LastUpdated: React.StatelessComponent<Props> = ({
  createdAt,
  activatedAt,
  supporters,
  updates,
}) => {
  const lastUpdated = getLastUpdated(
    createdAt,
    activatedAt,
    supporters,
    updates
  );

  return (
    <div className="jg-text--small jg-color--empress jg-space-mlms jg-space-mbsm">
      <Svg
        markup={clock}
        className="jg-display-i jg-icon--medium-small jg-fill--empress jg-space-mrxs"
      />
      <div className="jg-display-i">
        <FormattedMessage
          id="LastUpdated.message"
          defaultMessage="Page last updated on: {date} {time}"
          values={{
            date: <FormattedDate value={lastUpdated} />,
            time: <FormattedTime value={lastUpdated} />,
          }}
        />
      </div>
    </div>
  );
};

export default LastUpdated;



// WEBPACK FOOTER //
// ./src/components/LastUpdated/LastUpdated.tsx